
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"19","viewBox":"0 0 24 19","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M21 0H2.33333C1.05 0 0.0116667 1.05 0.0116667 2.33333L0 16.3333C0 17.6167 1.05 18.6667 2.33333 18.6667H21C22.2833 18.6667 23.3333 17.6167 23.3333 16.3333V2.33333C23.3333 1.05 22.2833 0 21 0ZM21 4.66667L11.6667 10.5L2.33333 4.66667V2.33333L11.6667 8.16667L21 2.33333V4.66667Z","fill":"white"}})])
          )
        }
      }
    